export default "/_next/static/media/Creative_Marketplace.f4e4d2e2353f0e1982c7aeccba6753fd.jpg";